import { Task } from 'views/pages/MyTasks/TaskDetail/types'
import { useTranslation } from 'react-i18next'
import { Icons, Progress, TextArea, Text } from '@agro-club/agroclub-shared'
import { AButton } from 'views/components/Analytics'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Card } from 'views/components/Card/Card'
import { InfoBlock } from '../../styled'
import { endpoints } from 'modules/endpoints'
import { useAProgress } from 'hooks/useAProgress'
import { apiClient } from 'modules/utils/httpClient'
import { useNotification } from 'hooks/useNotification'
import { MultilineText } from 'views/styled/common'
import styled from 'styled-components'
import { useState } from 'react'
import { Hr } from 'views/components/Hr/Hr'
import { TaskStatus } from 'modules/domain/task/types'
import { SetTaskToWorkButton } from '../StatusButtons'

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
  margin-top: 16px;
`

interface Props {
  task: Task
  taskRefetch: refetchFunc
}

export const CarrierSecurityRejected = ({ task, taskRefetch }: Props) => {
  const { t } = useTranslation('my_tasks')
  const notify = useNotification()
  const [comment, setComment] = useState('')

  const onSuccess = async () => {
    await taskRefetch()
  }

  const onError = (error) => {
    if (!error?.errors) return
    const errKeys = Object.keys(error.errors)
    let err = 'Ошибка'
    if (errKeys.length && error.errors[errKeys[0]]) {
      err = error.errors[errKeys[0]].toString()
    }
    notify(Progress.ERROR, { title: err })
  }

  const [progress, completeTask] = useAProgress(
    () => {
      return apiClient.post(
        comment.trim().length > 0
          ? endpoints.addResponseComment(task.id.toString())
          : endpoints.completeTask(task.id.toString()),
        { response_comment: comment },
      )
    },
    {
      eventName: 'finishVerification',
      analyticsPayload: {
        id: task.id.toString(),
      },
      onSuccess,
      onError,
    },
  )

  return (
    <Card.Container>
      <Card.GapableContent>
        <Card.Title>{t('detail.description')}</Card.Title>
        <InfoBlock>
          <Hr />
          <MultilineText>{task.comment}</MultilineText>
          <div style={{ marginTop: '16px' }}>
            {task.status === TaskStatus.in_progress && (
              <>
                <div style={{ marginBottom: '4px' }}>
                  <Text> {t('common:comment')}:</Text>
                </div>
                <TextArea value={comment} onChange={(e) => setComment(e.target.value)} />
                <ButtonsWrapper>
                  <AButton
                    color="secondary"
                    id="submit|aproveCarrier"
                    Icon={Icons.IconCheck}
                    onClick={completeTask}
                    progress={progress}
                  >
                    {t('executeTask')}
                  </AButton>
                </ButtonsWrapper>
              </>
            )}
            {task.status === TaskStatus.new && (
              <SetTaskToWorkButton taskId={task.id.toString()} refetch={taskRefetch} hideCurrentStatus />
            )}
          </div>
        </InfoBlock>
      </Card.GapableContent>
    </Card.Container>
  )
}
